package co.maytes.standupbot.dashboard.pages.oauth

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import co.maytes.standupbot.dashboard.stores.ToastKind
import co.maytes.standupbot.dashboard.stores.rememberAuthStore
import co.maytes.standupbot.dashboard.stores.rememberUiStore
import co.maytes.standupbot.dashboard.styles.Spacing
import co.maytes.standupbot.dashboard.styles.Typography
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.text.SpanText

/**
 * Slack OAuth callback. The backend handles the code exchange server-side,
 * sets the HttpOnly refresh cookie, then 302s here with either a success
 * signal (no `error` param) or an error query param like `?error=slack-denied`.
 *
 * We call `authStore.bootstrap()` so the just-minted refresh cookie turns
 * into an access token + `GET /api/v1/me` result, then route into the app.
 */
@Page("/oauth/slack-callback")
@Composable
fun SlackCallbackPage() {
    val ctx = rememberPageContext()
    val auth = rememberAuthStore()
    val ui = rememberUiStore()

    LaunchedEffect(Unit) {
        val error = ctx.route.params["error"]
        if (error != null) {
            ui.showToast("Slack connect failed: $error", ToastKind.Error)
            ctx.router.navigateTo("/")
            return@LaunchedEffect
        }
        auth.bootstrap()
        val returnTo = ctx.route.params["returnTo"]?.takeIf { it.startsWith("/") } ?: "/app"
        ctx.router.navigateTo(returnTo)
    }

    Box(
        modifier = Modifier.fillMaxSize().padding(Spacing.xxl),
        contentAlignment = Alignment.Center,
    ) {
        SpanText(
            text = "Finishing Slack connection…",
            modifier = Modifier.fontSize(Typography.body.size),
        )
    }
}
